import * as types from './mutations'
import router from '@/router'
import Vue from 'vue'

function defer()
{
    const deferred = {
        promise: null,
        resolve: null,
        reject: null
    }
    deferred.promise = new Promise((resolve, reject) => {
        deferred.resolve = resolve
        deferred.reject = reject
    })
    return deferred

}

const state = {
    channel: {},
    visitor: {},
    offers: [],
    stackedOffers: [],
    pages: [],
    page: {},
    thanksUrl: '/thank-you',
    stackedUrl: '/offers',
    component: null,
    deferred: defer(),
    subscription: {},
}

const mutations = {

    [types.SET_CHANNEL] (state, channel)
    {
        state.channel = channel
        if (state.channel && state.channel.thank_you_url)
        {
            state.thanksUrl = state.channel.thank_you_url
        }
        if (state.channel && state.channel.stacked_offers_url)
        {
            state.stackedUrl = state.channel.stacked_offers_url
        }
    },

    [types.SET_VISITOR] (state, visitor)
    {
        state.visitor = visitor
        state.subscription = visitor && visitor.subscription ? visitor.subscription : {}
    },

    [types.SET_OFFERS] (state, offers)
    {
        state.offers = offers
    },

    [types.SET_PAGE] (state, pages)
    {
        state.pages = pages
    },

    [types.SET_COMPONENT] (state, comp)
    {
        state.component = comp
    },

    [types.SET_CURRENT_PAGE] (state, page)
    {
        state.page = page
    },

    [types.SET_STACKED_OFFERS] (state, data)
    {
        state.stackedOffers = data
    }
}

const actions = {

    visit({commit, state})
    {
        return new Promise(async(resolve, reject) => {
            try {
                const params = router.history.current.query
                params.domain = window.location.hostname
                const response = await Vue.axios.get('/frontend', { params:  params })
                commit(types.SET_CHANNEL, response.data.channel)
                commit(types.SET_VISITOR, response.data.visitor)
                commit(types.SET_OFFERS, response.data.offers)
                commit(types.SET_STACKED_OFFERS, response.data.stacked_offers)
                commit(types.SET_PAGE, response.data.pages)
                state.deferred.resolve(response.data)
                resolve(response.data)
            } catch (e) {
                state.deferred.reject(e)
                reject(e)
            }
        })
    },

    signup({commit}, model)
    {
        return new Promise(async(resolve, reject) => {
            try {
                model.domain = window.location.hostname
                const response = await Vue.axios.post('/signup', model)
                commit(types.SET_VISITOR, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    activate(vuex, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                payload.model.domain = window.location.hostname
                const response = await Vue.axios.put(`/offer/${payload.id}/activate`, { fields: payload.model })
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    activateAllStacked({dispatch}, offers)
    {
        return new Promise(async(resolve) => {
            Object.keys(offers).map(async(key, index) => {
                const offer = offers[key]
                if (offer)
                {
                    await dispatch('activateStacked', key)
                }
            })
            resolve()
        })
    },

    activateStacked(vuex, id)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.put(`/stackedoffer/${id}/activate`, { domain: window.location.hostname })
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    real_activate({commit}, data)
    {
        commit(types.SET_VISITOR, data)
    },

    skip({commit}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.put(`/offer/${payload.id}/skip`, payload.model)
                commit(types.SET_VISITOR, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    setComponent({commit}, comp)
    {
        commit(types.SET_COMPONENT, comp)
    },

    setCurrentPage({commit}, page)
    {
        commit(types.SET_CURRENT_PAGE, page)
    },

    registerUser(undefined, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.post(`/auth/registerfromoutside`, payload, { baseURL: process.env.LOVERLY_API_URL })
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    }
}
const getters = {
    channel: state => JSON.parse(JSON.stringify(state.channel)),
    visitor: state => JSON.parse(JSON.stringify(state.visitor)),
    offers: state => JSON.parse(JSON.stringify(state.offers)),
    stackedOffers: state => JSON.parse(JSON.stringify(state.stackedOffers)),
    pages: state => JSON.parse(JSON.stringify(state.pages)),
    page: state => JSON.parse(JSON.stringify(state.page)),
    thanksUrl: state => JSON.parse(JSON.stringify(state.thanksUrl)),
    stackedUrl: state => JSON.parse(JSON.stringify(state.stackedUrl)),
    subscription: state => JSON.parse(JSON.stringify(state.subscription)),
    component: state => state.component,
    deferred: state => state.deferred,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/session/index.js